export const API_GOAL_PATH = '/api/white-cat/goal'
export const API_PROJECT_PATH = '/api/white-cat/project'
export const API_CLIENT_PATH = '/api/white-cat/client'
export const API_TARGET_GROUP_PATH = '/api/white-cat/target-group'
export const API_INDUSTRY_PATH = '/api/white-cat/industry'
export const API_ANALYSIS_PATH = '/api/white-cat/analysis'
export const API_CUSTOM_PREDICTION_PATH = '/api/white-cat/custom-prediction'
export const API_REFERENCE_PREDICTION_PATH = '/api/white-cat/reference-prediction'
